(function() {
    'use strict';
    angular.module('voyageReport')
        .directive('voyageReportSearch', voyageReportSearch)
        .directive('focusOn', function($timeout) {
            return {
                restrict: 'A',
                link: function(vm, $element, $attr) {
                    vm.$watch($attr.focusOn, function(_focusVal) {
                        $timeout(function() {
                            _focusVal ? $element[0].focus() : $element[0].blur();
                        });
                    });
                }
            }
        });

    function voyageReportSearch(MessageService, $stateParams, applicationConstants) {
        return {
            restrict: 'EA',
            scope: {
                onSearchVoyageReport: '&',
                showSearchArea: '=',
                crewTypes: '=',
                airports: '=',
                onChangeCrewType: '&',
                crewDetails: '='
            },
            templateUrl: 'voyage-report/directives/voyage-report-search-derective.tpl.html',
            replace: false,
            controllerAs: 'searchPanel',
            bindToController: true,
            controller: ['$scope',
                function($scope) {
                    
            	var vm = this;
                    vm.model = {
                        fromDate: '',
                        toDate: '',
                        crewTypeCode: '',
                        crewName: null,
                        crewId: null,
                        origin: null,
                        destination: null,
                        keywordFilter: null,
                        subject : null,
                        crewComment : null,
                        adminComment : null,                        
                        masterList: {}
                    };
                    vm.model.masterList = {
                        fromDateAfterToDate: false,
                        fromDateFormatInvalid: false,
                        toDateFormatInvalid: false
                    };
                    var height = (angular.element('.profile-tab-header').height() - 16);
                    angular.element(".profile-tab-content").css("top", height);
                    height = angular.element('.profile-tab-header>ul').height();
                    angular.element(".profile-tab-content").css("top", height);
                    height = 70 + angular.element('.profile-tab-header').height() + 40 + 15;
                    angular.element(".search_panel_new").css("top", height);

                    function isDateFormatInvalid(date) {
                        if (!!date && !moment(date, "DD/MM/YYYY")
                            .isValid()) {
                            return true;
                        }
                        return false;
                    };
                    
                    // check from date and to date
                    function istoDateBeforeFromDate() {
                        return moment(vm.model.toDate, "DD/MM/YYYY").isBefore(moment(vm.model.fromDate, "DD/MM/YYYY"));
                    };

                    function setDateValidationFlags() {
                        // if from date invalid
                        if (isDateFormatInvalid(vm.model.fromDate)) {
                            vm.model.masterList.fromDateFormatInvalid = true;
                            vm.model.masterList.fromDateAfterToDate = false;
                        } else {
                            vm.model.masterList.fromDateFormatInvalid = false;
                        }
                        // if to date invalid
                        if (isDateFormatInvalid(vm.model.toDate)) {
                            vm.model.masterList.toDateFormatInvalid = true;
                            vm.model.masterList.fromDateAfterToDate = false;
                        } else {
                            vm.model.masterList.toDateFormatInvalid = false;
                        }
                    };

                    function isValidSearchParams(params) {
                        setDateValidationFlags();
                        // if date invalid
                        if (vm.model.masterList.fromDateFormatInvalid || vm.model.masterList.toDateFormatInvalid) {
                            vm.model.masterList.fromDateAfterToDate = false;
                            return false;
                        } else if (istoDateBeforeFromDate()) {
                            vm.model.masterList.fromDateAfterToDate = true;
                            return false;
                        }
                        vm.model.masterList.fromDateAfterToDate = false;
                        return true;
                    }
                    vm.onSearchClick = function() {
                    	if (isValidSearchParams() && vm.model.fromDate && vm.model.toDate) vm.onSearchVoyageReport({
                    		'param': vm.model,'isNewSearch':true
                    	});
                    }
                    
                    // set Default Search Criteria
                    var moStart = moment().startOf("month");
                    var moEnd = moment().endOf("month");
                    vm.model.fromDate = moStart.format(applicationConstants.SETTINGS.DATE_FORMAT);
                    vm.model.toDate = moEnd.format(applicationConstants.SETTINGS.DATE_FORMAT);
                    vm.onSearchBarClick = function() {
                        vm.showSearchArea = !vm.showSearchArea;
                    }
                    
                    vm.onFromDateChange = function() {
                        if (vm.model.fromDate) {
                            var moEnd = moment(vm.model.fromDate, applicationConstants.SETTINGS.DATE_FORMAT)
                                .endOf("month");
                            vm.model.toDate = moEnd.format(applicationConstants.SETTINGS.DATE_FORMAT);
                        }
                    }
                    vm.loadCrewLists = function() {
                        vm.model.crewId = '';
                        vm.model.crewDetails = '';
                        if (!!vm.model.crewType) {
                            vm.onChangeCrewType({
                                crewType: vm.model.crewType.crewTypeCode
                            });
                        }
                    };
                    vm.setCrewID = function(){
                    	if(!!vm.model.crewDetails){
                    		vm.model.crewId = vm.model.crewDetails.crewId;
                    	}
                    }
                    vm.onCrewIdChange = function(){                    	
                    	vm.model.crewTypeCode = null;
                    	vm.model.crewType = null;
                    	vm.model.crewName = null;
                    	vm.model.crewDetails = null;
                    }
                }
            ],
            link: function(scope, element, attrs) {}
        };
    }
}());